import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";

import {getData} from '../../services/index';
import { Tabs ,Modal} from 'antd';
import { StickyContainer, Sticky } from 'react-sticky';
import 'antd/dist/antd.css';
import { message,Menu } from 'antd';
import { MailOutlined, AppstoreOutlined, SettingOutlined,DeleteOutlined } from '@ant-design/icons';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker,Select ,DatePicker,Timeline  } from 'antd';
import { PlusOutlined,MoreOutlined,FieldTimeOutlined,EditOutlined } from '@ant-design/icons';


import person from '../../assets/images/icon/person.png';
import deliveryman from '../../assets/images/icon/delivery-man.png';
import car from '../../assets/images/icon/car.png';
import bus from '../../assets/images/icon/bus_route.png';

const { SubMenu } = Menu;
const { TabPane } = Tabs;
const { Panel } = Collapse;
class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			visible: false,
			showMenu: 0,
			school_list: [],
			route_list: [],
			date: '',
			route_id: '',
			tag: '',
		}
		
		this.change_route = this.change_route.bind(this);	
		this.change_type = this.change_type.bind(this);	
		this.change_date = this.change_date.bind(this);	
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			this.setState({ user_id : storedArray['data'][0]['user_id'],school_id : storedArray['data'][0]['school_id'] });
			}
		this.checkData()
	}
	
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			
			var app = {school_id : school_id,user_id : user_id,}
			getData('erp/route_list_dropdown',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
						});
						
						
						
					}else{
						this.setState({
							school_list: [],
							
						});
					}
				}
			});
		setTimeout(() => {
						this.routedetails()
				}, 100);	
			
	}
  }
  
  routedetails(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			var user_id = storedArray['data'][0]['user_id'];
			var school_id = storedArray['data'][0]['school_id'];
			this.setState({route_list: []});
			var app = {school_id : school_id,user_id : user_id,route_id:this.state.route_id,tag:this.state.tag,date:this.state.date}
			getData('erp/route_tracker_history',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							route_list: result['data'],
						});
					}else{
						this.setState({
							route_list: [],
							
						});
					}
				}
			});
	}
  }
	
	change_route(event){
        this.setState({route_id: event});
		setTimeout(() => {
						this.routedetails()
				}, 100);			
    }
	change_type(event){
        this.setState({tag: event});	
		setTimeout(() => {
						this.routedetails()
				}, 100);
    }
	
	change_date(date, dateString) {
	  this.setState({ date: dateString,});
	  setTimeout(() => {
						this.routedetails()
				}, 100);
	}
	  
	  

	render() {
	var lenght = this.state.route_list.length; 
	const { current } = this.state;
	const { visible, loading } = this.state;	
		return (
		<div class="mobile_view">
			
			
      
      <div id="main">		
         <div class="row">
		 
		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					 <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Route Tracker History</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           <li class="breadcrumb-item"><a href="/transport-setup/route-tracker">Route Tracker</a>
                           </li>
						   <li class="breadcrumb-item active">Route Tracker History
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
		 
		 
			<div class="col col-md-12  ex-padd enquiry bg-off">
               <div class="container">
                  <section class="invoice-list-wrapper  section">
                    <div class="responsive-table iq-card bg-shadow-none">
					
					
					
					
					
					 
					 
					 
                    <div class=" no-footer mh-500 ">
					
						<div class="desktop-view">
                         <div class="top display-flex flow-root ">
							<div class="actions action-btns display-block align-items-center col col-md-12  right no-padd">
								<div class="col m3 s6 view-Profile">
									<Select onChange={this.change_route} defaultValue="Select Route Name">
									{this.state.school_list.map((list)=> (
										<Select.Option value={list.route_id}>{list.name}</Select.Option>
									))}
										
									</Select>
								</div>
								<div class="col m3 s6 view-Profile">
									<Select onChange={this.change_type} defaultValue="Select Type">
										<Select.Option value="Pickup">Pickup</Select.Option>
										<Select.Option value="Drop">Drop</Select.Option>
										
									</Select>
								</div>
								<div class="col m3 s6 view-Profile ">
									<DatePicker className="filter-date" onChange={this.change_date} />
								</div>
                             </div>
						</div>
                           
                        <div class="clear"></div>
						
						
						{this.state.route_list.map((data) => (
							<div class="col m12 s12 bg-white pt-20 pb-20 mh-500">
									
								
								{data.stop_array.map((list) => (	
									<>
									{(() => {
											if (list.type == "start" || list.type == "end") {
												return (
															<Timeline.Item color="blue">
																<div class="row no-margin">
																		<div class="children timeline communication ">
																			<Collapse
																				bordered={false}
																			  >
																				<Panel header={list.Stop} key={list.id}>
																					<div class="col m12 s12 no-padd">
																						<div class="col m12 s12 profile-details no-padd">	
																							{/* <p class="mb-0 pb-0 schedule">Scheduled Time : 1:05 PM</p>
																							<p class="mb-0 pb-0 arrive">Arrival Time : 1:05 PM</p> */}
																						</div>
																					</div>
																				</Panel>
																				
																			  </Collapse>
																		</div>
																</div>
															</Timeline.Item >
												)
											}else{
												return (
															<Timeline.Item color="blue">
																<div class="row no-margin">
																	<div class="children timeline communication ">
																		<Collapse
																			bordered={false}
																		  >
																			<Panel header={list.Stop} key={list.id}>
																				<div class="col m12 s12 no-padd">
																					<div class="col m12 s12 profile-details no-padd">	
																						<p class="mb-0 pb-0 schedule">Scheduled Time : {list.pickup_time}</p>
																						<p class="mb-0 pb-0 arrive">Arrival Time : {list.arrrival_time}</p>
																					</div>
																					<div class="col m12 s12 bus-track profile-details no-padd">	
																						<Checkbox.Group  name="children_id[]" onChange={this.onChangechecked}>
																						{list.student_array.map((student)=> (	
																						<>
																						   
																						   
																						   {(() => {
																								if (student.is_travel == "1") {
																									return (
																											<Checkbox value={1} id={1}><label class="w-m" for={1} defaultChecked={true} readonly>
																											   <div class="center"><img src={person} class="atd-img" /> {student.name} <img src={bus} class="bus-img"/></div>
																											   </label>
																										   </Checkbox>
																									)
																								}else{
																									return (
																											<Checkbox value={1} id={1}><label class="w-m" for={1} defaultChecked={true} readonly>
																											   <div class="center"><img src={person} class="atd-img" /> {student.name}</div>
																											   </label>
																										   </Checkbox>
																									)
																								}
																							})()}
																						   
																						</>   
																						))}   
																							
																						   
																						</Checkbox.Group>
																					</div>
																					
																				</div>
																			</Panel>
																			
																		  </Collapse>
																	</div>
															</div>
														</Timeline.Item >
												)
											
											}
									})()}
									
									</>
									
								))}	
								
								<div class="col m12 mt-20 children bg-blue attendance route-track bt pt-20">
														<h5>Driver Details</h5>
																  <div class="col m3 center"> 
																  <img src={data.driver_image} class="route-track-img"/> </div>
																  <div class="col m9 text-left"> 
																	<div class="col m12 mt-10"> <h6>Driver Name : {data.driver_name}</h6></div> 
																	<div class="col m12 mt-10"> <h6>Phone Number : {data.driver_mobile}</h6></div> 
																  </div>
																  
								</div>
								
							</div>
							
							
							
						))}	
						
						{(() => {
											if (lenght == "0") {
												return (
														<h6 class="center mt-20">No Routes Found</h6>
												)
											
											}
						})()}
                    </div>
					
					
					<div class="mobile-view">
						<div class="col m12">
								<div class="col m3 s6 view-Profile mb-10">
									<Select onChange={this.change_route} defaultValue="Select Route Name">
									{this.state.school_list.map((list)=> (
										<Select.Option value={list.route_id}>{list.name}</Select.Option>
									))}
										
									</Select>
								</div>
								<div class="col m3 s6 view-Profile mb-10 pr-0">
									<Select onChange={this.change_type} defaultValue="Select Type">
										<Select.Option value="Pickup">Pickup</Select.Option>
										<Select.Option value="Drop">Drop</Select.Option>
										
									</Select>
								</div>
								<div class="col m3 s6 view-Profile mb-10 route-history">
									<DatePicker className="filter-date" onChange={this.change_date} />
								</div>
						</div>
						<div class="col s12">
							{this.state.route_list.map((data) => (
									<div class="col m12 s12 bg-white pt-20 pb-20 mh-500 route-timeline">
											
										
										{data.stop_array.map((list) => (	
											<>
											{(() => {
													if (list.type == "start" || list.type == "end") {
														return (
																	<Timeline.Item color="blue">
																		<div class="row no-margin">
																				<div class="children timeline communication ">
																					<Collapse
																						bordered={false}
																					  >
																						<Panel header={list.Stop} key={list.id}>
																							<div class="col m12 s12 no-padd">
																								<div class="col m12 s12 profile-details no-padd">	
																									{/* <p class="mb-0 pb-0 schedule">Scheduled Time : 1:05 PM</p>
																									<p class="mb-0 pb-0 arrive">Arrival Time : 1:05 PM</p> */}
																								</div>
																							</div>
																						</Panel>
																						
																					  </Collapse>
																				</div>
																		</div>
																	</Timeline.Item >
														)
													}else{
														return (
																	<Timeline.Item color="blue">
																		<div class="row no-margin">
																			<div class="children timeline communication ">
																				<Collapse
																					bordered={false}
																				  >
																					<Panel header={list.Stop} key={list.id}>
																						<div class="col m12 s12 no-padd">
																							<div class="col m12 s12 profile-details no-padd">	
																								<p class="mb-0 pb-0 schedule">Scheduled Time : {list.pickup_time}</p>
																								<p class="mb-0 pb-0 arrive">Arrival Time : {list.arrrival_time}</p>
																							</div>
																							<div class="col m12 s12 bus-track mt-5 profile-details no-padd">	
																								
																								{list.student_array.map((student)=> (	
																								<>
																								   
																								   
																								   {(() => {
																										if (student.is_travel == "1") {
																											return (
																													
																												   <div class="col m2 s4 pt-10 center no-padd">
																														<h6 class="student-div"><img src={person} class="atd-img" /> {student.name} <img src={bus} class="bus-img"/></h6>
																													</div>
																											)
																										}else{
																											return (
																													<div class="col m2 s4 pt-10 center no-padd">
																														<h6 class="student-div"><img src={person} class="atd-img" /> {student.name} </h6>
																													</div>
																											)
																										}
																									})()}
																								   
																								</>   
																								))}   
																									
																								   
																								
																							</div>
																							
																						</div>
																					</Panel>
																					
																				  </Collapse>
																			</div>
																	</div>
																</Timeline.Item >
														)
													
													}
											})()}
											
											</>
											
										))}	
										
										<div class="col m12 mt-20 children bg-blue attendance route-trackno-padd">
											<div class="bt pt-10">
																	<h5>Driver Details</h5>
																			  <div class="col m3 s2 center no-padd"> <img src={deliveryman} class="route-track-img"/> </div>
																			  <div class="col m9 s10 text-left no-padd"> 
																				<div class="col m12 "> <h6 class="mb-0">Driver Name : <b>{data.driver_name} </b></h6></div> 
																				<div class="col m12"> <h6 class="mb-0">Phone Number : <b> {data.driver_mobile} </b></h6></div> 
																			  </div>
																			  
											</div>
										</div>
										
									</div>
								))}	
								
								{(() => {
											if (lenght == "0") {
												return (
														<h6 class="center mt-20">No Routes Found</h6>
												)
											
											}
								})()}
						</div>
					</div>
					
					
					
					
					
					
					
					
                        </div>
						
						
						
                     </div>
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>	
			
			
			
			
			
			
            <div class="content-overlay"></div>       
      </div>
      </div>
     

			</div>
		) 
	} 
}
export default Index;
